// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3W5wx","index":"styles_index__2G2IW"};